import { CLOSE_MODAL, OPEN_MODAL } from "./constants"

export const openModal = (modalProps) => ({
  modalContents: modalProps,
  hideCloseIcon: modalProps.hideCloseIcon,
  shouldCloseOnOverlayClick: modalProps.shouldCloseOnOverlayClick,
  type: OPEN_MODAL,
})

export const closeModal = () => ({
  type: CLOSE_MODAL,
})
